// src/hooks/useIdleTimer.js
import { useState, useEffect, useRef } from 'react';

const useIdleTimer = (onIdle, idleTimeInSeconds = 60) => { // 1 minute default
	const [isIdle, setIsIdle] = useState(false);
	const timeoutId = useRef(null);

	const resetTimer = () => {
		if (timeoutId.current) {
			clearTimeout(timeoutId.current);
		}
		setIsIdle(false);
		timeoutId.current = setTimeout(() => {
			setIsIdle(true);
			if (onIdle) {
				onIdle();
			}
		}, idleTimeInSeconds * 1000);
	};

	useEffect(() => {
		const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

		const handleEvent = () => {
			resetTimer();
		};

		events.forEach(event => {
			window.addEventListener(event, handleEvent);
		});

		resetTimer(); // Initialize timer

		return () => {
			events.forEach(event => {
				window.removeEventListener(event, handleEvent);
			});
			if (timeoutId.current) {
				clearTimeout(timeoutId.current);
			}
		};
	}, [onIdle, idleTimeInSeconds]);

	return { isIdle, resetTimer };
};

export default useIdleTimer;
